// Technical Review Constants
export const ASSET_STATUSES_URL =
  'TECHNICAL_REVIEW_ASSET_STATUSES_URL' as const;
export const ASSETS_URL = 'TECHNICAL_REVIEW_ASSETS_URL' as const;

export const ASSETS = 'assets' as const;
export const ASSET_STATUSES = 'assetStatuses' as const;
